module.exports = __webpack_public_path__ + "img/login2.bf0d4eff.png";